<div class="d-flex justify-content-between">
  <!--Delete-->
  @if (deleteBtnVisible) {
    <button
      type="button"
      class="btn btn-outline-danger btn-sm ag_grid_row_btn form-control py-0"
      style="margin-left: 2px; margin-right: 2px"
      [tooltip]="tooltip"
      placement="left"
      container="body"
      [disabled]="disabled"
      (click)="deleteClick()"
      >
      <i class="fa-solid fa-trash-can"></i>
    </button>
  }
</div>
